/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("ArrayInDataClass")
package features.userProducts.models

import kangaroorewards.appsdk.core.io.Model
import kotlin.js.ExperimentalJsExport
import kotlin.js.JsExport
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/**
 * User Product model class containing user product list
 */
@ExperimentalJsExport
@JsExport
@Serializable
data class UserProductsModel(
    /** Contains all user data */
    @SerialName("data")
    val data: UserProfileDataModel?,

    /** Contains products available to this user */
    @SerialName("included")
    val included: UserProductsIncluded?
) : Model()
